<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <vx-tour v-if="showThemeTour" :steps="steps" />

    <the-customizer
      v-if                    = "!disableCustomizer"
      :footerType             = "footerType"
      :hideScrollToTop        = "hideScrollToTop"
      :navbarType             = "navbarType"
      :navbarColor            = "navbarColor"
      :routerTransition       = "routerTransition"
      @toggleHideScrollToTop  = "toggleHideScrollToTop"
      @updateFooter           = "updateFooter"
      @updateNavbar           = "updateNavbar"
      @updateNavbarColor      = "updateNavbarColor"
      @updateRouterTransition = "updateRouterTransition" />
      
    <v-nav-menu
      :navMenuItems = "getMenuToDisplay()"
      title         = "Vuexy"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <!-- Compte en lecture seule (Broker Check → Broker Status) : bandeau sur
                   toutes les pages tant que le serveur pose x-read-only: 1. -->
              <vs-alert v-if="readOnlyUser" color="warning" icon-pack="feather" icon="icon-lock" :active="true" class="mb-4">
                {{ readOnlyText }}
              </vs-alert>

              <transition :name="isBrokerSection ? '' : routerTransition" :mode="isBrokerSection ? undefined : 'out-in'">
                <router-view :key="$route.fullPath" @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>

    <!-- MEETING module: global incoming-call popup, active-call surface,
         device check and What's new (calls are started from the navbar
         CallCenter, open to every user). -->
    <incoming-call-modal />
    <call-overlay />
    <device-check />
    <whats-new-modal />
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import navMenuItemsAccountant        from '@/layouts/components/vertical-nav-menu/navMenuItemsAccountant.js'
import navMenuItemsWoodFinder        from '@/layouts/components/vertical-nav-menu/navMenuItemsWoodFinder.js'
import navMenuItemsAttendance        from '@/layouts/components/vertical-nav-menu/navMenuItemsAttendance.js'
import navMenuItemsBroker        from '@/layouts/components/vertical-nav-menu/navMenuItemsBroker.js'
import TheCustomizer       from '@/layouts/components/customizer/TheCustomizer.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import IncomingCallModal   from '@/components/IncomingCallModal.vue'
import CallOverlay         from '@/components/CallOverlay.vue'
import DeviceCheck         from '@/components/DeviceCheck.vue'
import WhatsNewModal       from '@/components/WhatsNewModal.vue'
import meeting             from '@/services/meeting.js'
import { isReadOnlyUser, READ_ONLY_EVENT, READ_ONLY_TEXT } from '@/helpers/roleAccess.js'

const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarVertical,
    VNavMenu,
    VxTour,
    IncomingCallModal,
    CallOverlay,
    DeviceCheck,
    WhatsNewModal
  },
  data () {
    return {
      disableCustomizer : themeConfig.disableCustomizer,
      readOnlyUser      : isReadOnlyUser(),
      readOnlyText      : READ_ONLY_TEXT,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      navMenuItemsAccountant,
      navMenuItemsAttendance,
      navMenuItemsWoodFinder,
      navMenuItemsBroker,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [
        {
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.customizer-btn',
          content : 'Customize template based on your preference',
          params  : {
            placement: 'left'
          }
        },
        {
          target  : '.vs-button.buy-now',
          content : 'Buy this awesomeness at affordable price!',
          params  : {
            placement: 'top'
          }
        }
      ]
    }
  },
  watch: {
    '$route' (to) {
      this.routeTitle = to.meta.pageTitle
      const path = (to.path || '').replace(/^\/web/, '')
      if (path.indexOf('/broker') === 0 && this.$tours && this.$tours['vuexyTour']) {
        this.$tours['vuexyTour'].stop()
      }
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    callNotice (n) {
      if (n && n.text) {
        this.$vs.notify({ time: 4000, title: 'Call', text: n.text, color: n.color || 'warning', position: 'top-right' })
      }
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    callNotice () { return meeting.state.notice },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth },
    isBrokerSection () {
      const path = (this.$route && this.$route.path) || ''
      const normalized = path.replace(/^\/web/, '')
      if (normalized.indexOf('/broker') === 0) return true
      if (typeof window !== 'undefined' && window.location.pathname) {
        const loc = window.location.pathname.replace(/^\/web/, '')
        if (loc.indexOf('/broker') === 0) return true
      }
      return false
    },
    showThemeTour () {
      if (this.isBrokerSection) return false
      return !this.disableThemeTour
        && this.windowWidth >= 1200
        && this.mainLayoutType === 'vertical'
        && this.verticalNavMenuWidth === 'default'
    }
  },
  methods: {
    getMenuToDisplay () {
      if (localStorage.getItem('login-roles').toLowerCase().includes('accountant')) return navMenuItemsAccountant
      else if (localStorage.getItem('login-roles').toLowerCase().includes('attendance')) return navMenuItemsAttendance
      else if (localStorage.getItem('login-roles').toLowerCase().includes('wood finder')) return navMenuItemsWoodFinder
      else if (localStorage.getItem('login-roles').toLowerCase().includes('broker')) return navMenuItemsBroker
      else return navMenuItems
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // MEETING module: open the signaling socket now that the user is logged in
    // (Main.vue only renders for authenticated routes). Enables presence +
    // receiving incoming calls on any page.
    meeting.init()

    // Compte en lecture seule : le bandeau suit le drapeau de session (axios.js
    // le met à jour depuis l'en-tête x-read-only de chaque réponse).
    this.onReadOnlyChanged = (e) => { this.readOnlyUser = !!(e && e.detail && e.detail.readOnly) }
    window.addEventListener(READ_ONLY_EVENT, this.onReadOnlyChanged)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy () {
    if (this.onReadOnlyChanged) window.removeEventListener(READ_ONLY_EVENT, this.onReadOnlyChanged)
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>

